<template>
	<div
		class="vue-avatar--wrapper"
		:style="getStyles"
	>
		<span>{{ initials.toUpperCase() }}</span>
		<span
			class="img"
			:style="getImgStyles"
		></span>
	</div>
</template>
<script>
export default {
	name: 'Avatar',
	props: {
		src: {
			type: String,
			default: '',
		},
		name: {
			type: String,
			default: '',
		},
		color: {
			type: String,
			default: '',
		},
		background: {
			type: String,
			default: '',
		},
		size: {
			type: Number,
			default: 60,
		},
		alignCenter: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		getStyles() {
			return {
				color: this.color,
				width: `${this.size}px`,
				height: `${this.size}px`,
				lineHeight: `${this.size}px`,
				backgroundColor: this.background || undefined,
				margin: this.alignCenter ? '0 auto' : undefined,
				fontSize: `${this.size / 2.5}px`,
			};
		},
		getImgStyles() {
			return {
				backgroundImage: this.src ? `url(${this.src})` : undefined,
			};
		},
		initials() {
			const names = this.name.split(/\W/g);
			let initialLetters = '';
			if (names.length) {
				names.forEach((n, ind) => {
					if (ind === 0) {
						initialLetters += n.substring(0, 1);
					} else if (ind === names.length - 1) {
						initialLetters += n.substring(0, 1);
					}
				});
			}
			return initialLetters;
		},
	},
};
</script>
<style lang="scss">
.vue-avatar--wrapper {
	border-radius: 50%;
	text-align: center;
	position: relative;
	overflow: hidden;
	border: 1px solid #eee;
	span.img {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: no-repeat center/cover;
		display: block;
	}
}
</style>
